import {
  AnyObjectSchema,
  AnyObject,
  ObjectSchema,
  StringSchema,
  boolean,
  object,
  reach,
  string,
} from "yup";
import {
  AccountHolderInfo,
  ZuoraPaymentMethod,
  ZuoraPaymentMethodTypes,
} from "@/api/opb/opbTypes";
import { EditCreditCardPaymentMethodSchema } from "./PaymentMethodSchema";
import { EditPadAccountSchema } from "./PadAccountSchema";
import { EditBacsAccountSchema } from "./BacsAccountSchema";
import { EditSepaAccountSchema } from "./SepaAccountSchema";

export interface SavedPaymentMethodValues {
  nickname: string;
  defaultPayment: boolean;
  expirationDate: string;
  cvv: string;
  accountHolderInfo: Required<Omit<AccountHolderInfo, "accountHolderName">>;
}

const stringField = (
  schema: AnyObjectSchema,
  path: string
): StringSchema<string, AnyObject, "", "d"> =>
  (reach(schema, path) as StringSchema<string>).defined().default("");

export function editSavedPaymentMethodSchema(
  method: ZuoraPaymentMethod
): ObjectSchema<SavedPaymentMethodValues> {
  const isCard = method.type === ZuoraPaymentMethodTypes.CreditCard;
  const isPad = method.type === ZuoraPaymentMethodTypes.Pad;
  const isBacs = method.type === ZuoraPaymentMethodTypes.Bacs;
  const isSepa = method.type === ZuoraPaymentMethodTypes.Sepa;
  const isContactEditable = isPad || isBacs || isSepa;
  const card = EditCreditCardPaymentMethodSchema(
    isCard ? method.cardType : undefined
  );
  let zipCode = string().defined().default("");
  if (isPad)
    zipCode = stringField(EditPadAccountSchema, "accountHolderInfo.zipCode");
  if (isBacs)
    zipCode = stringField(EditBacsAccountSchema, "accountHolderInfo.zipCode");
  if (isSepa)
    zipCode = stringField(EditSepaAccountSchema, "accountHolderInfo.zipCode");
  return object({
    nickname: string().default(""),
    defaultPayment: boolean().default(false),
    expirationDate: isCard
      ? stringField(card, "expirationDate").required(
          "Expiration Date is required"
        )
      : string().default(""),
    cvv: isCard ? stringField(card, "cvv") : string().default(""),
    accountHolderInfo: object({
      addressLine1: string().default(""),
      addressLine2: string().default(""),
      email: isContactEditable
        ? stringField(EditSepaAccountSchema, "accountHolderInfo.email")
        : string().default(""),
      city: isContactEditable
        ? stringField(EditSepaAccountSchema, "accountHolderInfo.city")
        : string().default(""),
      zipCode,
      state: isPad
        ? stringField(EditPadAccountSchema, "accountHolderInfo.state")
        : string().default(""),
      phone: isPad
        ? stringField(EditPadAccountSchema, "accountHolderInfo.phone")
        : string().default(""),
      country: isSepa
        ? stringField(EditSepaAccountSchema, "accountHolderInfo.country")
        : string().default(""),
    }).required(),
  });
}
